import { useTranslation } from 'react-i18next'

import { Loader2 } from 'lucide-react'

export default function LoadingSpinner() {
  const { t } = useTranslation(['common'])
  return (
    <div className='bg-background flex h-screen items-center justify-center'>
      <div className='flex flex-col items-center space-y-3'>
        <Loader2 className='h-12 w-12 animate-spin text-blue-500' aria-label={t('common:loading.label', 'Loading')} />
        <p className='text-muted-foreground text-sm'>{t('common:loading.pleaseWait', 'Loading, please wait...')}</p>
      </div>
    </div>
  )
}
